export interface EntryData {
  dateKey: string;
  hasMigraine: boolean | null;
  painLevel: number | null;
  migraineDurationHours: number | null;
  symptoms: string[];
  spoons: number | null;
  medsTaken: "yes" | "no" | "partial" | null;
  outings: number | null;
  transportation: string[];
  appointments: string[];
  notes: string;
  weatherSummary: string | null;
  weatherCondition: string | null;
  weatherTemperatureMinC: number | null;
  weatherTemperatureMaxC: number | null;
  weatherHumidityAvgPct: number | null;
  weatherPressureMslAvgHpa: number | null;
  weatherSurfacePressureAvgHpa: number | null;
  weatherWindMaxKph: number | null;
  weatherWindGustMaxKph: number | null;
  weatherWindDirectionDeg: number | null;
  weatherPrecipitationMm: number | null;
  weatherApparentTempAvgC: number | null;
  weatherDewPointAvgC: number | null;
  weatherCloudCoverAvgPct: number | null;
  weatherVisibilityAvgM: number | null;
  weatherDateKey: string | null;
  weatherSource: "gps" | "city" | "manual" | null;
  weatherFetchedAt: string | null;
  updatedAt: string | null;
  clientUpdatedAt: string | null;
}

export const createEmptyEntry = (dateKey = ""): EntryData => ({
  dateKey,
  hasMigraine: null,
  painLevel: null,
  migraineDurationHours: null,
  symptoms: [],
  spoons: null,
  medsTaken: null,
  outings: null,
  transportation: [],
  appointments: [],
  notes: "",
  weatherSummary: null,
  weatherCondition: null,
  weatherTemperatureMinC: null,
  weatherTemperatureMaxC: null,
  weatherHumidityAvgPct: null,
  weatherPressureMslAvgHpa: null,
  weatherSurfacePressureAvgHpa: null,
  weatherWindMaxKph: null,
  weatherWindGustMaxKph: null,
  weatherWindDirectionDeg: null,
  weatherPrecipitationMm: null,
  weatherApparentTempAvgC: null,
  weatherDewPointAvgC: null,
  weatherCloudCoverAvgPct: null,
  weatherVisibilityAvgM: null,
  weatherDateKey: null,
  weatherSource: null,
  weatherFetchedAt: null,
  updatedAt: null,
  clientUpdatedAt: null,
});

export const entryHasAnyData = (entry?: EntryData): boolean => {
  if (!entry) {
    return false;
  }

  if (entry.hasMigraine !== null) {
    return true;
  }

  if (
    entry.painLevel !== null ||
    entry.migraineDurationHours !== null ||
    entry.spoons !== null ||
    entry.medsTaken !== null ||
    entry.outings !== null ||
    entry.transportation.length > 0
  ) {
    return true;
  }

  if (entry.symptoms.length > 0 || entry.appointments.length > 0) {
    return true;
  }

  return entry.notes.trim().length > 0;
};
